<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter, useStore } from 'dashboard/composables/store';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  filterType: { type: String, required: true },
  compact: { type: Boolean, default: false },
});
const { t } = useI18n();
const store = useStore();
const flags = useMapGetter('customViews/getUIFlags');
const suffix = computed(() =>
  props.filterType === 'contact' ? 'Contact' : 'Conversation'
);
const hasError = computed(() => flags.value[`has${suffix.value}Error`]);
const retry = () => store.dispatch('customViews/get', props.filterType);
</script>

<template>
  <div
    v-if="hasError"
    role="alert"
    class="m-2 flex shrink-0 flex-col items-start gap-2 rounded-xl border border-n-weak p-2 text-sm text-n-slate-12"
    :class="{ '!m-0 !items-center !border-0 !p-0': compact }"
  >
    <p class="m-0" :class="{ 'sr-only': compact }">
      {{ t('FILTER.SAVED_LOAD_ERROR') }}
    </p>
    <Button
      ghost
      slate
      icon="i-ph-arrow-clockwise"
      class="!min-h-11 !min-w-11"
      :label="compact ? undefined : t('FILTER.RETRY_LOAD')"
      :aria-label="t('FILTER.RETRY_LOAD')"
      @click="retry"
    />
  </div>
</template>
